import type { ReactNode } from "react";

export type Role =
  | "admin"
  | "super_admin"
  | "content_admin"
  | "content_creator"
  | "company_owner"
  | "system_admin";

export type Category =
  | "Overview"
  | "Locations"
  | "Content"
  | "People"
  | "Commerce";

export const CATEGORY_ORDER: Category[] = [
  "Overview",
  "Locations",
  "Content",
  "People",
  "Commerce",
];

export interface MenuItem {
  title: string;
  ref: string;
  roles?: Role[];
}

export interface MenuGroup {
  title: string;
  category: Category;
  icon: ReactNode;
  roles: Role[];
  menu: MenuItem[];
}
